// extracted by mini-css-extract-plugin
export default {"PfsMedlock":"PFSMedlock_PfsMedlock__ZYN+k","content":"PFSMedlock_content__ENPCM","homeBtn":"PFSMedlock_homeBtn__TUS2x","logo":"PFSMedlock_logo__vnJ+2"};